module.exports = __webpack_public_path__ + "img/Ancho_Fenomeno.de7cea81.png";